// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3P-KM","heading":"InfoRow_heading__3AuJH","value":"InfoRow_value__3H9lR","centered":"InfoRow_centered__WBbii"};